import React from 'react';
import './Footer.css';

const Footer = () => {
     return (
          <div className='bg-dark text-white '>
               <div className='footerOne container py-5'>
                    <div className='d-flex align-items-center justify-content-center '>
                         <div>
                              <img className='me-3' src="https://previews.123rf.com/images/fokaspokas/fokaspokas1806/fokaspokas180600329/103144523-customer-service-support-service-simple-icon-white-icon-with-shadow-on-transparent-background.jpg?fj=1" alt="" />
                         </div>
                         <div>
                              <h5>Always Open Line</h5>
                              <h5>Mobile : 01703022253</h5>
                         </div>

                    </div>
                    <div className='d-flex align-items-center justify-content-center '>
                         <div>
                              <img className='me-3' src="https://previews.123rf.com/images/fokaspokas/fokaspokas1803/fokaspokas180300251/96761246-telephone-receiver-icon-white-icon-with-shadow-on-transparent-background.jpg?fj=1" alt="" />
                         </div>
                         <div>
                              <h5>Office Hot line</h5>
                              <h5>Mobile : 01985511507</h5>
                         </div>

                    </div>
                    <div className='d-flex align-items-center justify-content-center '>
                         <div>
                              <img className='me-3' src="https://previews.123rf.com/images/fokaspokas/fokaspokas1803/fokaspokas180300294/96761254-icona-zoom-avanti-icona-bianca-con-ombra-su-sfondo-trasparente.jpg?fj=1" alt="" />
                         </div>
                         <div>
                              <h5>Location Old Dhaka</h5>
                              <h5>Noyabazar Brigze Road </h5>
                         </div>

                    </div>
               </div>
               <div className='bg-white w-100 border'>
               </div>

               <div className='footerTwo'>
                    <div className='d-flex justify-content-center py-4 '>
                         <div className='px-3'>
                              <h6 className='ps-1'>ABOUT US</h6>
                              <hr />
                              <p><small>Puran Dhaka 1000 <br></br> Abul hasanat road 1 lane</small></p>
                              <p><small>Mobile :  01985511507</small><br />
                                   <small>email : mdmaruf@5511507gmail.com</small></p>
                         </div>

                    </div>
                    <div className='d-flex justify-content-center py-4 '>
                         <div>
                              <h6 className='ps-4'>OUR SERVICES</h6>
                              <hr />
                              <ul>
                                   <li>✔ Engine Diagnostics</li>
                                   <li>✔ Lube, Oil and Filters</li>
                                   <li>✔ Belts and Hoses</li>
                                   <li>✔ Brake Repair</li>
                                   <li>✔ Tire and Wheel Services</li>
                                   <li>✔ Other Car Services</li>
                              </ul>






                         </div>

                    </div>

                    <div className='d-flex justify-content-center py-4 '>
                         <div>
                              <h6 className='ps-4'>HOURS</h6>
                              <hr />
                              <ul className='pe-4'>
                                   <li>Monday:7:30am - 5:30pm</li>
                                   <li>Tuesday:7:30am - 5:30pm</li>
                                   <li>Wednesday:7:30am - 5:30pm</li>
                                   <li>Thursday:7:30am - 5:30pm</li>
                                   <li>Friday: closed</li>
                                   <li>Saturday:7:30am - 3:00pm</li>
                                   <li>Sunday:7:30am - 5:30pm</li>
                              </ul>
                         </div>

                    </div>

                    <div className='d-flex justify-content-center py-4 '>
                         <div className='px-3'>
                              <h6>POPULAR TAGS</h6>
                              <hr />
                              <button>BELTS</button>
                              <button>BRAKES</button>
                              <button>DIAGNOSTICS</button>
                              <button>ENGINE</button>
                              <button>FILTERS</button>
                              <button>HEATING</button>
                              <button>OILS</button>
                              <button>STEERING</button>
                              <button>SUSPENSION</button>
                              <button>RIRES</button>
                              <button>TRANSMISSION</button>
                         </div>

                    </div>

               </div>

          </div>
     );
};

export default Footer;